// ============================================================
// Datei: src/pages/ressorts/hang/HangMobile.jsx
//
// ÄNDERUNGEN:
// - ShiftTable jetzt mit departmentName + filterFn
// - Aufbau / Abbau bleiben sauber getrennt
// - automatische Aktualisierung bleibt erhalten
// - reloadShifts bleibt unverändert erhalten
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import VolunteerPool from "../../../components/VolunteerPool";
import ShiftTable from "../../../components/shiftTable/ShiftTable";

// Guests
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./hangMobile.css";

const HangMobile = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers,
	reloadShifts,
	setSelectedVolunteer,
	downloadCcEmails
}) => {
	// ============================================================
	// STATE
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);
	const [helpersSubTab, setHelpersSubTab] = useState("ressort");

	// ============================================================
	// SHIFTS
	// ============================================================
	const hangAufbau = shifts.filter((s) => s.shiftId >= 350 && s.shiftId <= 369);
	const hangAbbau = shifts.filter((s) => s.shiftId >= 370 && s.shiftId <= 389);

	// ============================================================
	// TABS
	// ============================================================
	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{/* ================= HELPERS ================= */}
					{activeTab === "helpers" && (
						<div className="hang-mobile-helpers-panel">
							<div className="helpers-subtab-bar">
								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "ressort"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("ressort")}
								>
									Ressort
								</button>

								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "pool"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("pool")}
								>
									Helferpool
								</button>
							</div>

							{helpersSubTab === "ressort" && (
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={setSelectedVolunteer}
									reloadVolunteers={reloadVolunteers}
								/>
							)}

							{helpersSubTab === "pool" && (
								<VolunteerPool
									departmentName="Hang"
									onAssigned={() => {
										if (reloadVolunteers) {
											reloadVolunteers();
										}
									}}
								/>
							)}
						</div>
					)}

					{/* ================= SHIFTS ================= */}
					{activeTab === "shifts" && (
						<>
							<h3 className="hang-subheading">Aufbau</h3>
							<ShiftTable
								shifts={hangAufbau}
								departmentName="Hang"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 350 && shift.shiftId <= 369}
							/>

							<h3 className="hang-subheading">Abbau</h3>
							<ShiftTable
								shifts={hangAbbau}
								departmentName="Hang"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 370 && shift.shiftId <= 389}
							/>
						</>
					)}

					{/* ================= GUESTS ================= */}
					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}

					{/* ================= EXTRAS ================= */}
					{activeTab === "extras" && <div></div>}
				</div>
			</div>

			{/* ================= EDIT GUEST ================= */}
			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{/* ================= DELETE GUEST ================= */}
			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default HangMobile;